
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'src/app/i18n';
import { FixedBackgroundLight } from 'src/assets/background/Lights';
import BaseLayout, { BaseModelProps } from 'src/components/layouts/BaseLayout';
import VisionAnimation from 'src/components-pages/vision-values/Animation';
import VisionSeo, { visionImages } from 'src/components-pages/vision-values/seo';
import useVisionStyles from 'src/components-pages/vision-values/styles';
import { getBaseModels } from 'src/graphql/models/query';
import CommonTitle from 'src/components/common/CommonTitle';

interface Props extends BaseModelProps {}

const VisionValues = ({ baseData }: Props) => {
    const classes = useVisionStyles();
    const { t } = useTranslation('vision');
    return (
        <BaseLayout variant="dark" hasFooter baseData={baseData}>
            <VisionSeo />
            <FixedBackgroundLight />
            <Grid container>
                <Grid item sm={3} xs={12}>
                    <CommonTitle title={t('title')} />

                    <Typography
                        color="textPrimary"
                        variant="h5"
                        className={clsx(classes.fakeTitle, classes.hide)}>
                        {t('title')}
                    </Typography>
                </Grid>
                <Grid
                    item
                    sm={9}
                    xs={12}
                    className={clsx('Apsy-values-container', classes.contentGrid)}>
                    <VisionAnimation className={classes.video} />
                    <div className={classes.contentContainer} id="vision-main-container">
                        <Typography color="textPrimary" className={classes.content}>
                            {t('vision1')}
                        </Typography>
                        <div className={clsx(classes.content, classes.rowContent)}>
                            <Typography color="textPrimary" className={classes.shallowContent}>
                                {t('vision2')}
                            </Typography>
                            <img {...visionImages.puzzle[0]} className={classes.puzzle} />
                        </div>
                        <div className={clsx(classes.content, classes.centerContent)}>
                            <Typography color="textPrimary">{t('values1')}</Typography>

                            <img
                                {...visionImages.puzzle[1]}
                                className={clsx(classes.puzzle, classes.centerPuzzle)}
                            />
                        </div>
                        <ul>
                            <li>
                                <Typography color="textPrimary" className={classes.liContent}>
                                    {t('values_li1')}
                                </Typography>
                            </li>
                            <li>
                                <Typography color="textPrimary" className={classes.liContent}>
                                    {t('values_li2')}
                                </Typography>
                            </li>
                            <li>
                                <Typography color="textPrimary" className={classes.liContent}>
                                    {t('values_li3')}
                                </Typography>
                            </li>
                        </ul>
                    </div>
                </Grid>
            </Grid>
        </BaseLayout>
    );
};

 const _getStaticProps = async () => {
    const baseData = await getBaseModels();
    return {
        props: { baseData },
        revalidate: 100
    };
};

export default VisionValues;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/vision-values',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  